import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "referred_by";

export function getReferredBy() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

export default function ReferralTracker() {
  const location = useLocation();
  const [referredBy, setReferredBy] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const searchParams = new URLSearchParams(location.search);
    const referrerFromQuery = searchParams.get("referralApp");
    const existing = localStorage.getItem(STORAGE_KEY);

    // 1️⃣ If referralApp exists in URL → save it
    if (referrerFromQuery) {
      localStorage.setItem(STORAGE_KEY, referrerFromQuery);
      setReferredBy(referrerFromQuery);
      return;
    }

    // 2️⃣ If already saved → use it
    if (existing) {
      setReferredBy(existing);
      return;
    }

    // 3️⃣ Fallback → current page
    const currentPage = `${window.location.origin}${location.pathname}${location.search}`;
    localStorage.setItem(STORAGE_KEY, currentPage);
    setReferredBy(currentPage);
  }, [location]);

  return null; // tracking-only component
}